import React from "react";
import { toAbsoluteUrl } from "../../helpers/Reusable";
import { Link, useLocation } from "react-router-dom";

const RegisterConfirm = () => {
  const location = useLocation();
  const { userName } = location.state || "";
  return (
    <>
      <div className="w-full p-[5%] bg-yellow min-h-screen h-full">
        <div className="xxl:container mx-auto">
          <div className="flex justify-center items-center mb-[3rem] w-full">
            <img
              className="mx-auto"
              src={toAbsoluteUrl("media/img/logo/main-logo.svg")}
              alt=""
            />
          </div>
          <p className="text-center font-bold mb-[3rem] auth-text-b-lg">
            Thanks for creating an account on GCC Law Help.
          </p>
          <p className="text-center font-bold mb-[3rem] auth-text-b-lg">
            Your username is {userName}.
          </p>
          <p className="text-center font-bold mb-[3rem] auth-text-b-lg">
            You can access your account area to view orders, change your
            password, and more.
          </p>
          <p className="text-center font-bold mb-[3rem] auth-text-b-lg">
            We look forward to seeing you soon.
          </p>
          <p className="text-center font-bold  mb-[3rem] auth-text-b-lg">
            Thank you.
          </p>
          <div className="w-full text-center mb-[3rem]">
            <Link
              to="/login"
              className="font-bold underline  auth-text-b-lg"
            >
              Login
            </Link>
          </div>
          <p className="text-center font-bold mb-[3rem] auth-text-y-lg">
            Best Regards, <br/>
            GCC Law Help
          </p>
        </div>
      </div>
    </>
  );
};

export default RegisterConfirm;
